import { useEffect, useState } from "react";
import { DataTable } from "@/components/custom/DataTable";
import PageLayout from "@/components/custom/PageLayout";
import SearchFilter from "@/components/custom/SearchFilter";
import TopBar from "@/components/custom/TopBar";
import { useTheme } from "@/themeConfigs/ThemeContext";
import {
  HubChargerStatusInChargingColumn,
  useInChargingColumns,
} from "./columns";
import DashboardService from "@/services/api/DashboardService"; // Ensure the service is correctly imported
import { BottomNav } from "@/components/custom/BottomNav";
import { useHubDetails } from "@/redux/hooks/useSupervisorDetails";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

const InCharging = () => {
  const { theme } = useTheme();
  const columns = useInChargingColumns();
  const [data, setData] = useState<HubChargerStatusInChargingColumn[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const hubDetails = useHubDetails();

  const carsCharging = useSelector(
    (state: RootState) => state.chargerStatus.charger_status?.cars_charging
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response =
          await DashboardService.getChargerStatusDashboardDetails(
            hubDetails?.name as string,
            "ongoing"
          );
        if (response.success) {
          const transformedData = response.data.car_details.map((item) => ({
            charger_number: item.charger_code,
            vehicle_number: item.vrn,
            start_soc: `${item.start_soc}%`,
            current_soc: `${item.end_soc}%`, // Assuming 'current_soc' is similar to 'end_soc'
          }));
          setData(transformedData);
        }
      } catch (error) {
        console.error("Failed to fetch data", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);



  return (
    <>
      <PageLayout>
        <TopBar
          color={theme.colors.secondary}
          text="In Charging"
          number={carsCharging ? carsCharging.toString() : "0"}
        />
        {loading ? (
          <div>Loading...</div>
        ) : (
          
          <DataTable
            columns={columns}
            data={data}
            headerColor="bg-primary text-primary-foreground"
            alignment="center"
            rowsPerPage={10}
          />
        )}
      </PageLayout>
      <BottomNav active={1} />
    </>
  );
};

export default InCharging;
